import { render, staticRenderFns } from "./IgNewProductStock.vue?vue&type=template&id=c1a9011a&"
import script from "./IgNewProductStock.vue?vue&type=script&lang=js&"
export * from "./IgNewProductStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports